/**
 * VH-83: Multi-select for the canonical equipment vocabulary.
 *
 * Closed list comes from `services/recipes.js`. Display labels are i18n keys
 * under `recipes.equipment.labels.<key>`.
 */

import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { EQUIPMENT_KEYS } from '../../services/recipes'

export default function EquipmentTagsInput({
  value = [],
  onChange,
  disabled = false,
  options = EQUIPMENT_KEYS,
}) {
  const { t } = useTranslation()

  const toggle = (key) => {
    if (disabled) return
    const next = value.includes(key)
      ? value.filter((k) => k !== key)
      : [...value, key]
    onChange?.(next)
  }

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((key) => {
        const selected = value.includes(key)
        return (
          <button
            key={key}
            type="button"
            disabled={disabled}
            onClick={() => toggle(key)}
            className={clsx(
              'px-3 py-1.5 rounded-full border text-sm transition',
              'focus:outline-none focus:ring-2 focus:ring-primary-500',
              selected
                ? 'bg-primary-50 border-primary-500 text-primary-800'
                : 'bg-surface-container border-gray-300 text-gray-700 hover:bg-gray-50',
              disabled && 'opacity-60 cursor-not-allowed'
            )}
            aria-pressed={selected}
          >
            {t(`recipes.equipment.labels.${key}`, key)}
          </button>
        )
      })}
    </div>
  )
}
